import Vue, { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import { Input } from '@src/elements/input/input'

@Component({
  computed: {
    filteredName () {
      return this.$store.state.memberFilters.name
    }
  }
})
export class SearchMember extends Vue {

  private filteredName: string

  filterByName (value: string) {
    this.$store.dispatch('filterMembers', { name: value.trim() })
  }

  render (h: CreateElement) {
    return <Input value={this.filteredName} search={true} class='search-by-name' ref='nameFilter'
                  placeholder={this.$t('PAGE.MEMBERS.SEARCH.PLACEHOLDER')} valueChanged={this.filterByName} />
  }
}
